import { Controller } from '@hotwired/stimulus'
import Cookies from 'js-cookie'

export default class extends Controller {
  static targets = ['tpl']

  modalId () {
    return this.element.dataset.modalid
  }

  controllerForAdding () {
    return this.element.dataset.controllerforadding
  }

  controllerForUpdating () {
    return this.element.dataset.controllerforupdating
  }

  // モーダル本体は <template> に格納されており、初回 open 時に clone して live DOM へ挿入する。
  // clone 後の Stimulus target 解決は非同期のため、挿入した実要素の参照を自前で保持して同期的に操作する。
  ensureRendered () {
    if (this._rendered) return

    this.tplTarget.after(this.tplTarget.content.cloneNode(true))
    const modal = this.tplTarget.nextElementSibling
    this._modalEl = modal
    this._myFacilitiesModalAEl = modal.querySelector(`[data-${this.identifier}-target="myFacilitiesModalA"]`)
    this._inquiryModalAEl = modal.querySelector(`[data-${this.identifier}-target="inquiryModalA"]`)
    this._modalBEl = modal.querySelector(`[data-${this.identifier}-target="modalB"]`)
    this._myfacilitiesSentenceBEl = modal.querySelector(`[data-${this.identifier}-target="myfacilitiesSentenceB"]`)
    this._inquirySentenceBEl = modal.querySelector(`[data-${this.identifier}-target="inquirySentenceB"]`)
    this._rendered = true
  }

  openMyFacilitiesModal (e) {
    e.preventDefault()
    this.ensureRendered()

    this._modalEl.style.display = 'flex'
    this._myFacilitiesModalAEl.style.display = 'block'
    this._modalBEl.style.display = 'none'
  }

  openInquiryModal (e) {
    e.preventDefault()
    this.ensureRendered()

    this._modalEl.style.display = 'flex'
    this._inquiryModalAEl.style.display = 'block'
    this._modalBEl.style.display = 'none'
  }

  closeModal () {
    if (!this._rendered) return

    this._modalEl.style.display = 'none'
    this._inquiryModalAEl.style.display = 'none'
    this._myFacilitiesModalAEl.style.display = 'none'
    this._modalBEl.style.display = 'none'
  }

  enableMyFacilitiesModalB () {
    if (!this._rendered) return

    this._inquiryModalAEl.style.display = 'none'
    this._myFacilitiesModalAEl.style.display = 'none'
    this._modalBEl.style.display = 'block'
    this._myfacilitiesSentenceBEl.style.display = 'block'
    this._inquirySentenceBEl.style.display = 'none'
  }

  enableInquiryModalB () {
    if (!this._rendered) return

    this._inquiryModalAEl.style.display = 'none'
    this._myFacilitiesModalAEl.style.display = 'none'
    this._modalBEl.style.display = 'block'
    this._inquirySentenceBEl.style.display = 'block'
    this._myfacilitiesSentenceBEl.style.display = 'none'
  }

  registerVerifiedModalId (e) {
    const modalId = e.target.dataset.modalid
    Cookies.set('verified_modal_id', modalId)
    this.disableMyFacilitiesModal(modalId)
    this.disableInquiryModal(modalId)
  }

  disableMyFacilitiesModal (modalId) {
    if (!this.controllerForAdding() || !this.controllerForUpdating) return

    document.querySelectorAll('.myfacilities-with-modal').forEach((element) => {
      if (element.dataset.modalid === modalId) {
        element.dataset.action = `click->${this.controllerForAdding()}#add click->${this.controllerForUpdating()}#update`
      }
    })
  }

  disableInquiryModal (modalId) {
    document.querySelectorAll('.inquiry-with-modal').forEach((element) => {
      if (element.dataset.modalid === modalId) {
        element.dataset.action = ''
      }
    })
  }
}
